const venues = state => state.venues
const venue = state => state.venue

export default {
  venues,
  venue
};
